export const resetRankOptions = (rankOptions: any[]) =>
  rankOptions.map(item => ({
    ...item,
    selected: false,
  }));

export const resetNewCoachesOptions = (options: any[]) =>
  options.map(opt => ({
    ...opt,
    selected: opt.defaultVal,
  }));

export const resetFibcOptions = (options: any[]) =>
  options.map(opt => ({
    ...opt,
    selected: opt.defaultVal,
  }));

export const resetBonusOptions = (options: any[]) =>
  options.map(opt => ({
    ...opt,
    selected: false,
  }));
